export const STORAGE_KEYS = {
  productCode: 'productCode',
  processingOption: 'processingOption',
  businessInfo: 'businessInfo',
  packageInfo: 'packageInfo',
  packageId: 'packageId',
  billingInfo: 'billingInfo',
  billingHash: 'billingHash',
  billingCounter: 'billingCounter',
  upsellInfo: 'upsellInfo',
  contactUsInfo: 'contactUsInfo',
  preOrderFlag: 'preOrderFlag',
  orderBeforePayment: 'orderBeforePayment',
  orderAfterPayment: 'orderAfterPayment',
  orderAfterUpsell: 'orderAfterUpsell',
  gclid: 'gclid',
  source: 'source',
  keyword: 'keyword',
  adAccount: 'adAccount',
  requestUri: 'requestUri',
  crmSessionId: 'crmSessionId',
  step: 'step',
  fingerprint: 'fingerprint',
  firstClickURL: 'firstClickURL',
  saleURL: 'saleURL',
};
